.conversational-search-chat-elements-wrapper {
  overflow: clip; // removing double scroll bar for firefox browser
}
